
import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { Message } from 'src/app/_model/message';

@Injectable()
export abstract class MessagesDaoService implements Resetable {
  public abstract addMessage(messages: Message): Promise<void>;
  public abstract setMessageToRead(message: Message): Promise<void>;
  public abstract getMessages(): Promise<Message []>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
} 